import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { IncomingInvoiceDefaultApproverList } from "@msuite/utils/types";
import { client } from "@/hono";
import { useCitadel } from "@/hooks/use-citadel";

export function useIncomingInvoiceDefaultApprovers() {
	/** Hooks */
	const { citadel } = useCitadel();

	/** Query */
	// Read by the settings only, which `read Organization` already opens; waiting for the rule keeps
	// a caller without it from a 403 toast.
	const query = useQuery({
		queryKey: ["incoming-invoice-default-approvers"],
		enabled: citadel?.can("read", "Organization") === true,
		queryFn: async () => {
			const response = await client.incoming_invoices["default-approvers"].$get();
			const data = await responseHandler(response);
			return data.defaultApprovers as IncomingInvoiceDefaultApproverList;
		},
	});

	/** Return */
	return { ...query, defaultApprovers: query.data ?? [] };
}
